import {ShiftEntity} from "@ots-frontend/ots-data";
import {useEntityDataGrid, UseEntityDataGridProps, UseEntityDataGridResult} from "../EntityDataGrid/useEntityDataGrid";
import {useShiftDataGridCols} from "./useShiftDataGridCols";

export const EMPTY_ARRAY: ShiftEntity[] = []

export type UseShiftDataGridProps = Omit<UseEntityDataGridProps<ShiftEntity>, 'colsMap'>

export function useShiftDataGrid(props: UseShiftDataGridProps): UseEntityDataGridResult<ShiftEntity> {
  const {data = EMPTY_ARRAY, colWidths, ...rest} = props;

  const {colsMap} = useShiftDataGridCols({colWidths: colWidths})

  return useEntityDataGrid<ShiftEntity>({
    ...rest,
    colsMap: colsMap,
    colWidths: colWidths,
    data: data,
  })
}
